import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import GTM from 'react-gtm-module';
import useClientQuery from 'ui/hooks/useClientQuery';
import useLoanApplicationQuery from 'ui/hooks/useLoanApplicationQuery';

export const useGoogleTagManager = () => {
  const clientQuery = useClientQuery();
  const loanApplicationQuery = useLoanApplicationQuery();
  const { pathname } = useLocation();
  const initialized = useRef(false);
  const prevLocation = useRef<string>('');

  const logPageChange = async () => {
    const client = clientQuery.data;
    const clientApplication = loanApplicationQuery.loanApplication;

    GTM.dataLayer({
      dataLayer: {
        event: 'pageChange',
        page: {
          url: pathname,
          referrer: !initialized ? document.referrer : prevLocation.current,
        },
        client: client && {
          id: client.id,
          dateOfBirth: client.dateOfBirth,
          clientNumber: client.number,
          clientStatus: client.status,
          age: client.age,
          identifiedBy: client.identifiedBy,
          registeredBy: client.registeredBy,
        },
        application: clientApplication && {
          id: clientApplication.id,
          amount: clientApplication.amount,
          term: clientApplication.term,
        },
      },
    });
    prevLocation.current = pathname;
  };

  useEffect(() => {
    const gtmId = process.env.REACT_APP_GTM;

    if (!gtmId) return;

    if (!initialized.current) {
      GTM.initialize({ gtmId });
      initialized.current = true;

      // Track basic JavaScript errors
      window.addEventListener('error', function (e) {
        GTM.dataLayer({
          dataLayer: {
            event: 'error',
            message: e.message,
            stacktrace: e.error?.stack,
            path: pathname,
          },
        });
      });
    }

    if (!initialized) {
      logPageChange();
    } else if (prevLocation.current !== pathname) {
      logPageChange();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
};
